export const PROJECT_NAME = 'reports'

export const REQUEST_CONTROL_PATH = 'request_control'
